/* ============================================================
   YOLÈTE — Nouvelles boucles du dossier « Site internet produits »
   (les 6 nouveautés + N15 fournies détourées par le client).
   Chargé APRÈS data.js/tiges-catalog, AVANT catalog-enrich pour
   que les collections soient dérivées automatiquement.
   Prix indicatifs à confirmer avec la maison.
   ============================================================ */
(function () {
  if (typeof PRODUCTS === 'undefined') return;
  var C = 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/cut__boucles__';
  function B(id, name, w, price, style, descr) {
    var img = C + id + '.png';
    return {
      id: id, name: name, type: 'boucle', width: w, style: style, audience: 'femme',
      price: price, img: img, images: [img], colors: [], descr: descr, isNew: true
    };
  }
  /* Largeurs et prix vérifiés dans les books (Saisonnier p.13,14,16,22,23,24 ; Annuel p.17). */
  var add = [
    B('boucle-n365', 'BOUCLE N365/25', 25, 19.5, 'Intemporelle',
      'Boucle intemporelle Yolète, ligne épurée, pour nos cuirs de largeur 25 mm.'),
    B('boucle-n383', 'BOUCLE N383/25', 25, 55, 'Jungle',
      'Boucle crocodile, pièce statement à l esprit animalier sauvage, en 25 mm.'),
    B('boucle-n405', 'BOUCLE N405', 40, 149, 'Voglio Bene',
      'Boucle émaillée sertie, cabochon central cerclé de cristaux.'),
    B('boucle-n411', 'BOUCLE N411', 40, 89, 'Bijou',
      'Boucle signature Yolète, plaque rectangulaire au logo de la maison.'),
    B('boucle-n412', 'BOUCLE N412', 40, 79.9, 'Bijou',
      'Boucle signature Yolète, médaillon ovale au logo de la maison.'),
    B('boucle-n408-25', 'BOUCLE N408/25', 25, 85, 'Intemporelle',
      'Boucle fine 25 mm, travail ciselé, pour nos cuirs de largeur 25 mm.'),
    B('boucle-n15-25', 'BOUCLE N15/25', 25, 38, 'Voglio Bene',
      'Boucle émaillée 25 mm, motif graphique, pour nos cuirs de largeur 25 mm.')
  ];
  var have = {};
  for (var i = 0; i < PRODUCTS.length; i++) have[PRODUCTS[i].id] = 1;
  for (var j = 0; j < add.length; j++) if (!have[add[j].id]) PRODUCTS.push(add[j]);
})();
